import { Model } from './model';
import { Type } from 'class-transformer';
import { TransformStringToDayJS, TransformStringToNumber } from './utils';
import { DeductionReason } from './deduction_reason';
import { Vendor } from './vendor';
import dayjs from 'dayjs';
import { Partner } from './partner';
import { LinkedIntegration } from './linked_integration';
import { Payment } from './payment';
import { PaymentAllocation } from './payment_allocation';

export enum CreditMemoStatus {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  VOID = 'void',
}

export class CreditMemo extends Model {
  id: string;

  currency: string;

  allowance_reference: string | null;

  @Type(() => CreditMemoAllocation)
  allocations: CreditMemoAllocation[];

  @TransformStringToNumber()
  applied_amount: number;

  @TransformStringToNumber()
  remaining_amount: number;

  customer_reference: string | null;

  @TransformStringToNumber()
  gross_amount: number;

  @TransformStringToNumber()
  net_amount: number;

  @TransformStringToNumber()
  tax_amount: number;

  @TransformStringToNumber()
  discount_amount: number;

  @TransformStringToDayJS(true)
  due_date: dayjs.Dayjs | null;

  document_number: string | null;

  number: string | null;

  is_updating: boolean;

  @TransformStringToDayJS()
  last_synced_at: dayjs.Dayjs | null;

  @Type(() => CreditMemoLineItem)
  line_items: CreditMemoLineItem[];

  linked_integration_id: string | null;

  linked_integration: LinkedIntegration | null;

  @TransformStringToDayJS()
  paid_at: dayjs.Dayjs | null;

  partner_id: string;

  @Type(() => Partner)
  partner: Partner;

  pdf: string | null;

  pdf_id: string | null;

  @TransformStringToDayJS(true)
  posted_date: dayjs.Dayjs | null;

  remote_id: string;

  remote_pdf_url: string | null;

  remote_status: string | null;

  status: CreditMemoStatus;

  custom_fields: Record<string, { label: string; value: string }> | null;
}

export class CreditMemoLineItem extends Model {
  id: string;

  currency: string;

  description: string;

  gross_amount: number;

  net_amount: number;

  tax_amount: number;

  quantity: string;

  price: number;

  vendor_id: string | null;

  @Type(() => Vendor)
  vendor: Vendor | null;

  @Type(() => DeductionReason)
  reason: DeductionReason | null;
}

export class CreditMemoAllocation extends PaymentAllocation {
  @Type(() => Payment)
  payment: Payment;
}
